// components/modules/Pricing/PricingSection.tsx
import React from "react";
import { IPricingPlan, PricingCard } from "./PricingCard";
import { Translate } from "@/components/common/Translate/Translate";
import IncompleteStatusMessageBanner from "components/modules/Dashboard/Dashboard/IncompleteStatusMessageBanner";

export const stripeProducts = {
    pro: process.env.NEXT_PUBLIC_IR_ENV === "prod" ? "prod_RydeTyddCpwdip" : "prod_Rfa9UYXGlaCI8U",
    ultra: process.env.NEXT_PUBLIC_IR_ENV === "prod" ? "prod_Ryde3DhnHYEx3T" : "prod_RfaANNbjOb2fBF",
};

const pricingData: IPricingPlan[] = [
    {
        id: "free",
        title: "Free",
        subtitle: <Translate keyName="subtitle-1" />,
        price: 0,
        period: <Translate keyName="month" />,
        features: [
            { feature: <Translate keyName="free-feature-1" /> },
            { feature: <Translate keyName="free-feature-2" /> },
            { feature: <Translate keyName="free-feature-3" /> },
            { feature: <Translate keyName="free-feature-4" /> },
            { feature: <Translate keyName="free-feature-5" /> },
            { feature: <Translate keyName="free-feature-6" /> },
            { feature: <Translate keyName="free-feature-7" /> },
            { feature: <Translate keyName="free-feature-8" /> },
            { feature: <Translate keyName="free-feature-9" /> },
        ],
    },
    {
        id: "pro",
        title: "Pro",
        subtitle: <Translate keyName="subtitle-2" />,
        price: 6.99,
        period: <Translate keyName="month" />,
        stripeProductId: stripeProducts.pro,
        features: [
            { feature: <Translate keyName="pro-feature-1" /> },
            { feature: <Translate keyName="pro-feature-2" /> },
            { feature: <Translate keyName="pro-feature-3" /> },
            { feature: <Translate keyName="pro-feature-4" /> },
            { feature: <Translate keyName="pro-feature-5" /> },
            { feature: <Translate keyName="pro-feature-6" /> },
            { feature: <Translate keyName="pro-feature-7" /> },
            { feature: <Translate keyName="pro-feature-8" /> },
            { feature: <Translate keyName="pro-feature-9" /> },
        ],
        isPopular: true,
    },
    {
        id: "ultra",
        title: "Ultra",
        subtitle: <Translate keyName="subtitle-3" />,
        price: 9.99,
        period: <Translate keyName="month" />,
        stripeProductId: stripeProducts.ultra,
        features: [
            { feature: <Translate keyName="ultra-feature-1" /> },
            { feature: <Translate keyName="ultra-feature-2" /> },
            { feature: <Translate keyName="ultra-feature-3" /> },
            { feature: <Translate keyName="ultra-feature-4" /> },
            { feature: <Translate keyName="ultra-feature-5" /> },
            { feature: <Translate keyName="ultra-feature-6" /> },
            { feature: <Translate keyName="ultra-feature-7" /> },
            { feature: <Translate keyName="ultra-feature-8" /> },
            { feature: <Translate keyName="ultra-feature-9" /> },
        ],
    },
];

export const PricingSection: React.FC = () => {
    return (
        <div id="pricing-cards-section" className="py-8 px-4 sm:px-6 max-w-7xl mx-auto">
            <div className="text-center mb-8 sm:mb-12">
                <h2 className="text-2xl sm:text-3xl font-bold mb-4">
                    <Translate keyName="title" />
                </h2>
                <p className="text-gray-600 dark:text-gray-400 text-sm sm:text-base">
                    <Translate keyName="sub-title" />
                </p>
            </div>

            <IncompleteStatusMessageBanner />
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 p-4 sm:p-8 md:p-10">
                {pricingData.map((plan, index) => (
                    <PricingCard key={index} plan={plan} />
                ))}
            </div>
        </div>
    );
};
